const failureMessages = {
    invalidUserCredentials: 'Invalid user credentials',
    userNotFound: "User not found!",
    passwordInvalidContent: "Password must have a minimum length of 8 characters containing at least one number, an uppercase, and a special character",
    passwordOldPasswordIsSame: "Old password and new password cannot be the same",
    mailInvalidContent: 'Invalid email format',
    phoneInvalidContent: "Please enter valid phone number",
    confirmPasswordMsg: "Passwords must match",
    passwordIsMissing: "Password field is missing",
    confirmPasswordIsMissing: "confirmPassword field is missing",
    phoneNumberAssignedToLead: "Your Phone Number is set as preferred contact in your lead",
    emailAlreadyExist: "This account is already registered… Please login",
    emailNotRegistered: "Email is not registered",
    authorizationMissing: 'Authorization is missing',
    notBearer: "Authorization header is not type of Bearer",
    notBearerType: "Authorization header has too many part is must follow this patter 'Bearer xx.yy.zz",
    paymentNotCompleted: "Payment is not completed, please retry",
    leadUIDIsMissing: "Lead UID is missing. Please refresh the page and try again",
    leadNotFound: "Lead is not found",
    domainNameIsMissing: "domainName key is mandatory",
    UIDIsMissing: "UID is required",
    EbookMaxDownloadMsg: "You have downloaded E-book two times already",
    notAuthorizedMsg: "You are not authorized to access this page",
    userAlreadyExist: "User already exists, please login!",
    commentFieldIsEmpty: "Comment field is empty!",
    fieldIsEmpty: "Field is empty",
    userUIDIsMissing: "userUID is missing",
    OTPIsMissing: 'Please enter OTP!',
    requiredFieldIsMissing: 'Required field is missing!',
    OTPExpired: 'OTP Expired!',
    registrarUIDIsMissing: "Registrar UID is missing",
    permissionDenied: "Permission denied!",
    fieldsMissingMessage: "Fields are missing",
    payloadEmpty: "Payload is empty",
    invalidEntry: "Invalid entry",
    errorParsingData: "Error in parsing request",
    enterPhoneNumber: "Please enter phone number",
    imageOnlyError: "Please upload only .jpg, .jpeg, .png type files",
    requestBodyIsInvalid: "The request body is invalid",
    inValidImageType: "Invalid image input",
    registrarUIDNotFound: "Registrar UID is not found!",
    unknownInputField: "Unknown input field"
}

export default failureMessages
